// extracted by mini-css-extract-plugin
export default {"dashboardContainer":"mails_dashboardContainer__YMSsl","MuiGrid-item":"mails_MuiGrid-item__Nz1ZV","MuiPaper-root":"mails_MuiPaper-root__QM3-B"};